import axios from "axios";
import qs from "qs";

const http = axios.create({
  baseURL: "/ophApi",
  timeout: 1000 * 180,
  withCredentials: true,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
  transformRequest: (data, headers) => {
    switch (headers["Content-Type"]) {
      case "application/x-www-form-urlencoded":
        return qs.stringify(data);
      case "multipart/form-data":
        return data;
      case "application/json":
        return JSON.stringify(data);
    }
  },
});

export default http;
